__turbopack_context__.v({
  "wrapper": "AssetsSparkSurface-module__vBa1CG__wrapper",
});
